import React, {Component} from "react";
import {Divider, Grid, MenuItem, Select, Stack} from "@mui/material";
import {connect} from "react-redux";
import Typography from "@mui/material/Typography";
import {StyledSwitch} from "../components/StyledComponents";
import {updateKeyboardShortcuts} from "../../../redux_actions/morpheus.setting.action";
import {defaultKeyboardShortcuts} from "../keys/defaultKeyboardShortcuts";
import {getZoomPresets, ZOOM_PRESET_CHOICES} from "../openseadragon/utils/zoomPresets";
import {getSeenAreaKey, SEEN_AREA_BINDING, SEEN_AREA_KEY_CHOICES} from "../openseadragon/seenArea/holdToggle";


class ShortcutsApp extends Component {

	constructor(props) {
		super(props);

		if (Object.keys(this.props.keyboard_shortcuts).length < Object.keys(defaultKeyboardShortcuts).length)
			this.props.dispatch(updateKeyboardShortcuts(defaultKeyboardShortcuts));  // default for new users
	}

	isEnable = () => this.props.keyboard_shortcuts['enabled'];

	toggle = (e) => {
		e.target.blur();
		let shortcuts = this.props.keyboard_shortcuts;
		let shortcutEnabled = shortcuts['enabled'];
		this.props.dispatch(updateKeyboardShortcuts({...shortcuts, enabled: !shortcutEnabled}));
	}

	// TODO: [Priyanshu] enable user to edit keyboard shortcuts
	updateKeyboardShortcut = (id, shortcut) =>
		this.props.dispatch(updateKeyboardShortcuts({
			[id]: shortcut
		}));

	// The PATCH replaces keyboard_shortcuts, so send the whole object.
	updateBinding = (key, value) => {
		let shortcuts = this.props.keyboard_shortcuts;
		this.props.dispatch(updateKeyboardShortcuts({
			...shortcuts,
			bindings: {...(shortcuts.bindings || {}), [key]: value},
		}));
	}

	renderZoomPresets = () => {
		let presets = getZoomPresets(this.props.keyboard_shortcuts);
		return <Stack direction={"column"} spacing={1}>
			<Typography sx={{fontWeight: 700}}>Zoom keys (OpenSeadragon viewer)</Typography>
			{Object.keys(presets).map(key =>
				<Stack key={key} direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
					<Select size="small" variant="standard" value={presets[key]}
							onChange={e => this.updateBinding(key, e.target.value)}>
						{[...new Set([...ZOOM_PRESET_CHOICES, presets[key]])].sort((a, b) => a - b).map(choice =>
							<MenuItem key={choice} value={choice}>Zoom to {choice}×</MenuItem>)}
					</Select>
					<Typography color={"secondary"} sx={{mr: 2, fontWeight: 500}}>{key}</Typography>
				</Stack>
			)}
			<Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
				<Typography sx={{fontWeight: 500}}>Fit to screen</Typography>
				<Typography color={"secondary"} sx={{mr: 2, fontWeight: 500}}>G</Typography>
			</Stack>
			{this.props.canViewSeenArea &&
				<Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
					<Typography sx={{fontWeight: 500}}>Seen-area heatmap (tap toggles, hold peeks)</Typography>
					<Select size="small" variant="standard" sx={{mr: 2}}
							value={getSeenAreaKey(this.props.keyboard_shortcuts)}
							onChange={e => this.updateBinding(SEEN_AREA_BINDING, e.target.value)}>
						{SEEN_AREA_KEY_CHOICES.map(key => <MenuItem key={key} value={key}>{key}</MenuItem>)}
					</Select>
				</Stack>}
		</Stack>
	}

	render() {
		let keyboardShortcuts = this.props.keyboard_shortcuts;

		return <Grid>
			<Grid item xs={12}>
				<h3 style={{color: "white", textAlign : 'center', marginTop: '10px'}}>Keyboard Shortcuts</h3>
				<Divider style={{margin: "10px"}} />
			</Grid>
			<Stack direction={"row"} alignItems="center" justifyContent={"space-between"}>
				<Typography sx={{fontWeight : 700}}>Enable</Typography>
				<StyledSwitch color={"secondary"} checked={this.isEnable()} onChange={this.toggle}></StyledSwitch>
			</Stack>
			<Divider style={{margin: "10px"}} />
			<Stack direction={"column"} spacing={1}>
				{Object.keys(keyboardShortcuts).filter(id => keyboardShortcuts[id]?.label).sort((id1, id2) =>
					keyboardShortcuts[id1].shortcut?.toString() > keyboardShortcuts[id2].shortcut?.toString() ? 1 : -1)
					.map(id =>
					<Stack key={id} direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
						<Typography sx={{fontWeight : 500}}>{keyboardShortcuts[id].label}</Typography>
						<Typography color={"secondary"} sx={{mr: 2, fontWeight : 500}}>
							{keyboardShortcuts[id].shortcut}</Typography>
					</Stack>
				)}
			</Stack>
			<Divider style={{margin: "10px"}} />
			{this.renderZoomPresets()}
		</Grid>
	}
}

const mapStateToProps = (state) => {
	let {keyboard_shortcuts} = state.morpheusSettingReducer;
	return {keyboard_shortcuts, canViewSeenArea: !!state.osdViewerConfigReducer?.permissions?.can_view_seen_heatmap};
};

export default connect(mapStateToProps)(ShortcutsApp);
